<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <div class="row">
      <div class="col-md-12">
        <pr-input-radio
          formControlName="hasOneYearFinanceExperience"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="Expérience professionnelle d'au moins 1 an dans la finance"
        >
        </pr-input-radio>
      </div>
    </div>
  </form-wrapper>

  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
